// Workflows (Agent 4C, Runde 4): Liste, Editor (eine Spalte mit aufklappbaren Schritten) und Läufe-Tabelle.
// Runde 10 (10A): Berichte (`berichte`, `:id/bericht`) und Blackout Dates (`blackout`).
// Die Route ist `/workflows/*`; die Unterseiten hängen hier, die Bausteine liegen in `src/workflows/`, der Client in
// `src/api/workflows.ts`, die Routen stehen in API.md 19.1.
import { Navigate, Route, Routes } from "react-router-dom";
import BerichtSeite from "../workflows/BerichtSeite";
import BerichteUebersicht from "../workflows/BerichteUebersicht";
import BlackoutSeite from "../workflows/BlackoutSeite";
import LaeufeSeite from "../workflows/LaeufeSeite";
import WorkflowEditor from "../workflows/WorkflowEditor";
import WorkflowListe from "../workflows/WorkflowListe";
import "../workflows/workflows.css";

export default function Workflows() {
  return (
    <Routes>
      <Route index element={<WorkflowListe />} />
      <Route path="neu" element={<WorkflowEditor />} />
      <Route path="laeufe" element={<LaeufeSeite />} />
      <Route path="berichte" element={<BerichteUebersicht />} />
      <Route path="blackout" element={<BlackoutSeite />} />
      <Route path=":workflowId/bericht" element={<BerichtSeite />} />
      <Route path=":workflowId" element={<WorkflowEditor />} />
      <Route path="*" element={<Navigate to="/workflows" replace />} />
    </Routes>
  );
}
